import { Link } from 'react-router-dom';
import { siteIntro, siteName } from '@/mocks/site';

const features = [
  { icon: 'ri-layout-grid-line', title: '清晰分类体系', desc: '电影、电视剧、综艺、动漫一目了然，快速定位目标内容。' },
  { icon: 'ri-filter-3-line', title: '多维筛选检索', desc: '按类型、地区、年份筛选，配合热度与更新时间排序。' },
  { icon: 'ri-bookmark-line', title: '本地收藏记录', desc: '收藏影视保存在浏览器本地，无需登录即可随时回看。' },
  { icon: 'ri-sparkling-line', title: '智能相关推荐', desc: '基于标签匹配相关作品，发现更多感兴趣的影视内容。' },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-information-line"></i>
              关于本站
            </span>
            <h2 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              在信息的海洋里，找到你真正想看的
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">{siteIntro}</p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to="/category"
                className="flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
              >
                <i className="ri-compass-3-line"></i>
                开始浏览
              </Link>
              <Link
                to="/special"
                className="flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-700 whitespace-nowrap"
              >
                <i className="ri-magic-line"></i>
                查看专题策划
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {features.map((f) => (
              <div key={f.title} className="rounded-lg border border-background-200 bg-background-100 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${f.icon} text-xl`}></i>
                </span>
                <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">{f.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <p className="mt-10 rounded-lg bg-secondary-50 px-5 py-4 text-xs leading-relaxed text-secondary-900">
          <i className="ri-error-warning-line mr-1"></i>
          {siteName} 为影视内容信息展示平台，所有影视资料、海报与热度数据均为演示内容，站点不提供在线播放、下载及任何付费服务。
        </p>
      </div>
    </section>
  );
}